/*  ========================================================================
    # Scripts - Location Presentation
    ========================================================================  */

const LocationPresentation = {
  cfg: {
    locationPresentationSections: document.querySelectorAll('.s-location-presentation'),
    locationParam: ''
  },

  /**
   * Handler.
   */
  handler() {
    this.cfg.locationPresentationSections.forEach(entry => {
      // declaration of the elements
      const locationContentEntries = entry.querySelectorAll('[data-presentation]');
      const locationTriggerEntries = entry.querySelectorAll('[data-presentation-target]');
      const locationVideos = entry.querySelectorAll(
        '.s-location-presentation__location-preview-image--video'
      );
      const locationVideoDialog = entry.querySelector('.c-dialog');
      const locationVideoDialogClose = entry.querySelector('.c-dialog__close');

      // the logic
      locationTriggerEntries.forEach(locationEntry => {
        if (this.cfg.locationParam === locationEntry.getAttribute('data-presentation-label')) {
          this.activateLocation(locationEntry, locationContentEntries, locationTriggerEntries);
        }

        locationEntry.addEventListener('click', () => {
          this.activateLocation(locationEntry, locationContentEntries, locationTriggerEntries);
        });

        // Key up/down feature
        locationEntry.addEventListener('keydown', event => {
          const key = event.key;
          if (key === 'ArrowDown' || key === 'ArrowUp') {
            event.preventDefault();
            const nextEntry =
              key === 'ArrowDown'
                ? locationEntry.nextElementSibling
                : locationEntry.previousElementSibling;

            if (nextEntry && nextEntry.hasAttribute('data-presentation-target')) {
              this.activateLocation(nextEntry, locationContentEntries, locationTriggerEntries);
            }
          }
        });
      });

      locationVideos.forEach(lVentry => {
        lVentry.querySelector('button').addEventListener('click', () => {
          locationVideoDialog.showModal();
          locationVideoDialog.classList.add('c-dialog--active');
          const video = locationVideoDialog.querySelector('video');
          video.src = lVentry.getAttribute('data-url');
          video.setAttribute('type', lVentry.getAttribute('data-type'));
          video.controls = true;
          video.play();
        });
      });

      locationVideoDialogClose.addEventListener('click', () => {
        locationVideoDialog.close();
      });
      locationVideoDialog.addEventListener('close', () => {
        locationVideoDialog.classList.remove('c-dialog--active');
        locationVideoDialog.querySelector('video').pause();
      });
    });
  },

  activateLocation(locationEntry, locationContentEntries, locationTriggerEntries) {
    const tabTarget = locationEntry.getAttribute('data-presentation-target');
    locationEntry.setAttribute('aria-selected', 'true');
    locationEntry.setAttribute('tabindex', '0');
    locationEntry.focus();
    locationEntry.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });

    locationContentEntries.forEach(contentEntry => {
      if (contentEntry.getAttribute('data-presentation') === tabTarget) {
        contentEntry.setAttribute('data-active', '');
      } else {
        contentEntry.removeAttribute('data-active');
      }
    });

    locationTriggerEntries.forEach(ltEntry => {
      if (ltEntry.getAttribute('data-presentation-target') !== tabTarget) {
        ltEntry.setAttribute('aria-selected', 'false');
        ltEntry.setAttribute('tabindex', '-1');
      }
    });
  },

  /**
   * Initialize.
   */
  init() {
    // get the url param
    const urlParams = new URLSearchParams(window.location.search);
    const standortParam = urlParams.get('standort');
    if (standortParam) this.cfg.locationParam = standortParam;

    if (this.cfg.locationPresentationSections.length > 0) this.handler();
  }
};

export default LocationPresentation;
